import { Grid, Icon } from '@chakra-ui/react';
import { FC, ReactElement } from 'react';
import { FaSearchPlus } from 'react-icons/fa';
export interface IIconHover {
  icon?: ReactElement;
}
export const IconHover: FC<IIconHover> = ({ icon = <Icon as={FaSearchPlus} boxSize="12" color="white" />, ...props }) => {
  return (
    <Grid
      placeItems={'center'}
      transition={'opacity .2s ease-in'}
      _groupHover={{ opacity: 0.6 }}
      backgroundColor="gray.700"
      position={'absolute'}
      inset={0}
      w={'full'}
      h={'full'}
      cursor={'pointer'}
      opacity={0}
      {...props}
    >
      {icon}
    </Grid>
  );
};

export default IconHover;
